import { render } from "./Excel.vue?vue&type=template&id=7a5a97c5&ts=true"
import script from "./Excel.vue?vue&type=script&lang=ts"
export * from "./Excel.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__